import { KoForm, KoFormBuilder, KoRichTextEditor } from 'packages';
import React, { useCallback } from 'react';
import styles from './categories.module.scss';

const CategoriesCurd = ({ form, initialValues = {}, handleFinish }) => {
  const enabledButtons = {
    bold: true,
    italic: true,
    underline: true,
    strikethrough: true,
    color: true,
    backgroundColor: true,
    alignLeft: true,
    alignCenter: true,
    alignRight: true,
    alignJustify: true,
    numberedList: true,
    unorderedList: true,
    codeBlock: true,
    link: true,
    insertTable: true,
    uploadImageButton: true,
    uploadVideoButton: true
  };

  const Description = ({ value, onChange }) => (
    <KoRichTextEditor
      enabledButtons={enabledButtons}
      value={value}
      form={form}
      name="description"
      onSetEditorValues={v => onChange(v)}
    />
  );

  const meta = {
    columns: 4,
    initialValues: initialValues,
    colon: true,
    fields: [
      {
        key: "name",
        label: "Name",
        colSpan: 4,
        placeholder: "Enter Category Name",
        rules: [{ required: true }]
      },
      {
        key: "description",
        widget: Description,
        label: "Description",
        colSpan: 4,
        placeholder: "Enter description"
      }
    ]
  };

  const handleSubmit = useCallback(values => {
    handleFinish(values);
  }, [handleFinish]);

  return (
    <div className={styles.formWrapper}>
      <KoForm form={form} layout="vertical"
        onFinish={handleSubmit} onSubmit={handleSubmit}
      >
        <KoFormBuilder  form={form} meta={meta} />
      </KoForm>
    </div>
  );
};

export default CategoriesCurd;
